import React, { useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import "./AdvantagesLayouts.css";

const DEFAULT_ADVANTAGES = [
  {
    title: "Integrated Sections",
    text: "LARIS connects all lab departments, from sample collection to report delivery, enhancing efficiency with dedicated dashboards for every role.",
  },
  {
    title: "Unified Workflow",
    text: "Each segment of your lab works in sync, ensuring smooth operations and optimal resource management without disruptions.",
  },
  {
    title: "Synchronized Outcome",
    text: "LARIS ensures fast, accurate results while boosting profitability through efficient and synchronized lab operations.",
  },
];

/** Cards Split - Desktop only: 3-card grid with left accent bar */
function AdvantagesLayoutCardsSplit({ items = DEFAULT_ADVANTAGES, inView }) {
  return (
    <div className={`advantages-layout advantages-cards-split ${inView ? "advantages-in-view" : ""}`}>
      <div className="advantages-grid advantages-grid-cards">
        {items.map((item, idx) => (
          <div key={idx} className="advantages-card" style={{ animationDelay: `${idx * 0.12}s` }}>
            <div className="advantages-content">
              <h4>{item.title}</h4>
              <p className="mb-0">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/** Border Left - Mobile only: stacked cards with left green border */
function AdvantagesLayoutBorderLeft({ items = DEFAULT_ADVANTAGES, inView }) {
  return (
    <div className={`advantages-layout advantages-border-left ${inView ? "advantages-in-view" : ""}`}>
      {items.map((item, idx) => (
        <div key={idx} className="advantages-border-left-item" style={{ animationDelay: `${idx * 0.1}s` }}>
          <div className="advantages-border-left-content">
            <h4>{item.title}</h4>
            <p>{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * Responsive advantages section: Cards Split on desktop, Border Left on mobile.
 * No layout selector - single fixed responsive layout.
 */
export function AdvantagesLayoutSelector({ items = DEFAULT_ADVANTAGES }) {
  const [inView, setInView] = useState(false);
  const wasVisibleRef = useRef(false);

  const handleVisibility = (visible) => {
    if (visible && !wasVisibleRef.current) {
      setInView(true);
      wasVisibleRef.current = true;
    }
  };

  return (
    <VisibilitySensor onChange={handleVisibility} partialVisibility offset={{ bottom: 80 }}>
      <div className={`advantages-section-wrap advantages-modern advantages-responsive ${inView ? "advantages-in-view" : ""}`}>
        <div className="advantages-desktop-only">
          <AdvantagesLayoutCardsSplit items={items} inView={inView} />
        </div>
        <div className="advantages-mobile-only">
          <AdvantagesLayoutBorderLeft items={items} inView={inView} />
        </div>
      </div>
    </VisibilitySensor>
  );
}
